import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./drop-down-footer.module.css";
export function DropDownFooter(_a) {
    var className = _a.className, children = _a.children;
    return (_jsx("div", { className: classNames(styles["drop-down-footer"], className), children: children }));
}
